import { MutationTree } from 'vuex';
import { ManagerState } from '@/store/modules/manager/index';
import { OfficesModel } from '@/models/Offices.model';
import {
  ADD_MANUAL_FORM,
  MANAGER_RESET_STATE,
  REMOVE_DIRTY_MANUAL_FORM,
  REMOVE_MANUAL_FORM,
  RESET_EMPLOYEES_FORMS_SEARCH_OBJECT,
  RESET_FORMS_SEARCH_OBJECT,
  SET_APPROVE_FORM_ERRORS,
  SET_CAN_APPROVE,
  SET_CAN_REJECT,
  SET_CUBE,
  SET_CUBE_DETAILS,
  SET_CUBE_DETAILS_ERRORS,
  SET_CUBE_SEARCH_OBJECT,
  SET_CUBES_INFO,
  SET_CUBES_INFO_ERRORS, SET_CUBES_STATS, SET_CUBES_STATS_ERRORS, SET_CUBES_STATS_LOADING,
  SET_EMPLOYEE_EMAIL,
  SET_FORM101_CHANGES,
  SET_FORM101_OFFICES_LIST,
  SET_FORM101_SECTION_NAMES,
  SET_FORM101_SECTION_NOTES,
  SET_FORM101_UNITS_LIST,
  SET_FORM101_UNITS_LOADING,
  SET_FORM_101_CHANGES_NOTES_ERRORS,
  SET_FORM_101_FILTERS_LIST,
  SET_FORM_101_REJECT_REASON,
  SET_FORM_101_STATUSES_LIST,
  SET_FORM_STATUS_HISTORY,
  SET_FORMS_RESULT_DATA,
  SET_FORMS_SEARCH_ERRORS,
  SET_FORMS_SEARCH_FILTERS,
  SET_FORMS_SEARCH_OBJECT,
  SET_ID_NUMBER_FIELDS_DATA,
  SET_MANAGER_LOADING,
  SET_MANAGER_MODE, SET_MANUAL_UPDATE_IPT_MODAL_ERRORS,
  SET_MASKIT_MODE,
  SET_ADP_MODE,
  SET_OPEN_APPROVE_FORMS_MODAL,
  SET_OPEN_APPROVE_FORMS_MODAL_ERRORS,
  SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL,
  SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS,
  SET_OPEN_MANUAL_FORM_MODAL, SET_OPEN_MANUAL_UPDATE_IPT_MODAL,
  SET_OPEN_REMOVE_FORM_MODAL,
  SET_OPEN_REMOVE_FORM_MODAL_ERRORS,
  SET_REJECT_FORM_ERRORS,
  SET_RESET_PASSWORD_LOADING,
  SET_SEARCH_EMPLOYEES_CURRENT_FORM,
  SET_SELECTED_FORMS_TO_APPROVE,
  SET_STATISTICS,
  SET_STATISTICS_ERRORS,
  SET_STATISTICS_OFFICES,
  SET_STATUS_DESC,
} from '@/types/managerForm.types';
import { UnitsModel } from '@/models/Units.model';
import { Form101SearchModel } from '@/models/Form101Search.model';
import { Grid } from '@/models/Grid.model';
import { Form101StatisticsModel } from '@/models/manager/Form101Statistics.model';
import { CodeTable } from '@/models/base/CodeTable.interface';
import { ManagerForm101Data } from '@/models/manager/ManagerForm101Data.model';
import { CubesInfoModel } from '@/models/manager/CubesInfo.model';
import { ApproveFormRequest } from '@/models/manager/ApproveFormRequest';
import { Document } from '@/models/form/Documents.model';
import { initialState } from '@/store/modules/manager';
import { GetIdNumberFieldsResponseModel } from '@/models/manager/GetIdNumberFieldsResponse.model';
import { FormsSearchFilters } from '@/models/manager/forms-search-filters';
import { CubesStatsModel } from '@/models/manager/CubesStats.model';

export const mutations: MutationTree<ManagerState> = {

  [SET_FORM101_OFFICES_LIST]: (state, offices: OfficesModel[]) => {
    if (!offices.length) {
      state.offices = [];
    } else {
      state.offices = offices;
    }
  },

  [SET_FORM101_UNITS_LIST]: (state, units: UnitsModel[]) => {
    if (!units.length) {
      state.units = [];
    } else {
      state.units = units;
    }
  },

  [SET_FORM101_UNITS_LOADING]: (state, form101UnitsListLoading: boolean) => {
    state.form101UnitsListLoading = form101UnitsListLoading;
  },

  [SET_FORM_101_FILTERS_LIST]: (state, form101Filters: any[]) => {
    state.form101Filters = form101Filters;
  },

  [SET_FORMS_SEARCH_OBJECT]: (state, form101SearchObject: Form101SearchModel) => {
    state.form101SearchObject = form101SearchObject;
  },

  [SET_FORMS_SEARCH_FILTERS]: (state, formsSearchFilters: FormsSearchFilters[]) => {
    state.formsSearchFilters = formsSearchFilters;
  },

  [RESET_EMPLOYEES_FORMS_SEARCH_OBJECT]: (state) => {
    state.form101SearchObject = {
      searchType: 2,
      taxYear: new Date().getFullYear(),
    };
    state.formsResultData = {} as Grid;
    state.formsSearchFilters = [];
    state.units = [];
  },

  [RESET_FORMS_SEARCH_OBJECT]: (state) => {
    state.form101SearchObject = {
      searchType: 2,
      taxYear: new Date().getFullYear(),
    };
  },

  [SET_FORMS_RESULT_DATA]: (state, formsResultData: Grid) => {
    state.formsResultData = formsResultData;
  },

  [SET_FORMS_SEARCH_ERRORS]: (state, formsSearchErrors: string[]) => {
    state.formsSearchErrors = formsSearchErrors;
  },

  [SET_STATISTICS]: (state, statistics: Form101StatisticsModel[]) => {
    state.statistics = statistics;
  },

  [SET_STATISTICS_ERRORS]: (state, statisticsErrors: any) => {
    state.statisticsErrors = statisticsErrors;
  },

  [SET_STATISTICS_OFFICES]: (state, statisticsOffices: OfficesModel[]) => {
    state.statisticsOffices = statisticsOffices;
  },

  [SET_MANAGER_MODE]: (state, managerMode: boolean) => {
    state.managerMode = managerMode;
  },

  [SET_MANAGER_LOADING]: (state, managerLoading: boolean) => {
    state.managerLoading = managerLoading;
  },

  [SET_FORM_STATUS_HISTORY]: (state, formStatusHistory: Grid) => {
    state.formStatusHistory = formStatusHistory;
  },

  [SET_FORM101_CHANGES]: (state, form101Changes: any) => {
    state.form101Changes = form101Changes;
  },

  [SET_FORM101_SECTION_NAMES]: (state, form101SectionNames: any) => {
    state.form101SectionNames = form101SectionNames;
  },

  [SET_FORM101_SECTION_NOTES]: (state, form101SectionNotes: object) => {
    state.form101SectionNotes = form101SectionNotes;
  },

  [SET_APPROVE_FORM_ERRORS]: (state, approveFormErrors: string[]) => {
    state.approveFormErrors = approveFormErrors;
  },

  [SET_REJECT_FORM_ERRORS]: (state, rejectFormErrors: string[]) => {
    state.rejectFormErrors = rejectFormErrors;
  },

  [SET_OPEN_REMOVE_FORM_MODAL]: (state, openRemoveFormModal: boolean) => {
    state.openRemoveFormModal = openRemoveFormModal;
  },

  [SET_OPEN_REMOVE_FORM_MODAL_ERRORS]: (state, openRemoveFormModalErrors: string[]) => {
    state.openRemoveFormModalErrors = openRemoveFormModalErrors;
  },

  [SET_FORM_101_CHANGES_NOTES_ERRORS]: (state, form101ChangesNotesErrors: string[]) => {
    state.form101ChangesNotesErrors = form101ChangesNotesErrors;
  },

  [SET_FORM_101_STATUSES_LIST]: (state, form101StatusesList: CodeTable[]) => {
    state.form101StatusesList = form101StatusesList;
  },

  [SET_SEARCH_EMPLOYEES_CURRENT_FORM]: (state, searchEmployeesCurrentForm: ManagerForm101Data) => {
    state.searchEmployeesCurrentForm = searchEmployeesCurrentForm;
  },

  [SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL]: (state, openManagerFormResetPasswordModal: boolean) => {
    state.openManagerFormResetPasswordModal = openManagerFormResetPasswordModal;
  },

  [SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS]: (state, formResetPasswordModalErrors: string[]) => {
    state.openManagerFormResetPasswordModalErrors = formResetPasswordModalErrors;
  },

  [SET_EMPLOYEE_EMAIL]: (state, employeeEmail: string) => {
    state.employeeEmail = employeeEmail;
  },

  [SET_CUBES_INFO]: (state, cubesInfo: CubesInfoModel[]) => {
    state.cubesInfo = cubesInfo;
  },

  [SET_CUBES_INFO_ERRORS]: (state, cubesInfoErrors: string[]) => {
    state.cubesInfoErrors = cubesInfoErrors;
  },

  [SET_CUBE_DETAILS]: (state, cubeDetails: Grid) => {
    state.cubeDetails = cubeDetails;
  },

  [SET_CUBE_DETAILS_ERRORS]: (state, cubeDetailsErrors: string[]) => {
    state.cubeDetailsErrors = cubeDetailsErrors;
  },

  [SET_MASKIT_MODE]: (state, maskitMode: boolean) => {
    state.maskitMode = maskitMode;
  },

  [SET_ADP_MODE]: (state, adpMode: boolean) => {
    state.adpMode = adpMode;
  },

  [SET_OPEN_APPROVE_FORMS_MODAL]: (state, openApproveFormsModal: boolean) => {
    state.openApproveFormsModal = openApproveFormsModal;
  },

  [SET_OPEN_APPROVE_FORMS_MODAL_ERRORS]: (state, approveFormsErrors: string[]) => {
    state.openApproveFormsModalErrors = approveFormsErrors;
  },

  [SET_SELECTED_FORMS_TO_APPROVE]: (state, selectedFormsToApprove: ApproveFormRequest[]) => {
    state.selectedFormsToApprove = selectedFormsToApprove;
  },

  [SET_ID_NUMBER_FIELDS_DATA]: (state, idNumberFields: GetIdNumberFieldsResponseModel) => {
    state.idNumberFields = idNumberFields;
  },

  [ADD_MANUAL_FORM]: (state, doc: Document) => {
    state.manualForms = [doc];
  },

  [REMOVE_MANUAL_FORM]: (state, docId: number | string | undefined) => {
    if (docId !== undefined) {
      let filteredDocuments: Document[] = initialState().manualForms;
      for (const key in state.manualForms) {
        if (Object.prototype.hasOwnProperty.call(state.manualForms, key)) {
          filteredDocuments = [
            ...state.manualForms.filter((document: Document) => document.docId !== docId),
          ];
        }
      }
      state.manualForms = filteredDocuments;
    } else {
      state.manualForms = [];
    }
  },

  [REMOVE_DIRTY_MANUAL_FORM]: (state) => {
    let filteredDocuments: Document[] = initialState().manualForms;
    for (const key in state.manualForms) {
      if (Object.prototype.hasOwnProperty.call(state.manualForms, key)) {
        filteredDocuments = [
          ...state.manualForms.filter((document: Document) => !!document.docId),
        ];
      }
    }
    state.manualForms = filteredDocuments;
  },

  [SET_CAN_APPROVE]: (state, canApprove: boolean) => {
    state.canApprove = canApprove;
  },

  [SET_CAN_REJECT]: (state, canReject: boolean) => {
    state.canReject = canReject;
  },

  [SET_STATUS_DESC]: (state, statusDesc: string) => {
    state.statusDesc = statusDesc;
  },

  [SET_OPEN_MANUAL_FORM_MODAL]: (state, openManualFormModal: boolean) => {
    state.openManualFormModal = openManualFormModal;
  },

  [SET_FORM_101_REJECT_REASON]: (state, form101RejectReason: string) => {
    state.form101RejectReason = form101RejectReason;
  },

  [SET_CUBE]: (state, cube: CubesInfoModel) => {
    state.cube = cube;
  },

  [SET_CUBE_SEARCH_OBJECT]: (state, cubeSearchObject: Form101SearchModel) => {
    state.cubeSearchObject = cubeSearchObject;
  },

  [SET_RESET_PASSWORD_LOADING]: (state, resetPasswordLoading: boolean) => {
    state.resetPasswordLoading = resetPasswordLoading;
  },

  [SET_CUBES_STATS]: (state, cubesStats: CubesStatsModel) => {
    state.cubesStats = cubesStats;
  },

  [SET_CUBES_STATS_LOADING]: (state, cubesStatsLoading: boolean) => {
    state.cubesStatsLoading = cubesStatsLoading;
  },

  [SET_CUBES_STATS_ERRORS]: (state, cubesStatsErrors: string[]) => {
    state.cubesStatsErrors = cubesStatsErrors;
  },

  [SET_OPEN_MANUAL_UPDATE_IPT_MODAL]: (state, openManualUpdateIptModal: boolean) => {
    state.openManualUpdateIptModal = openManualUpdateIptModal;
  },

  [SET_MANUAL_UPDATE_IPT_MODAL_ERRORS]: (state, manualUpdateIptModalErrors: string[]) => {
    state.manualUpdateIptModalErrors = manualUpdateIptModalErrors;
  },

  [MANAGER_RESET_STATE]: (state) => {
    state = Object.assign(state, initialState());
  },

};
